import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { CssBaseline } from '@material-ui/core';
import { MsalProvider, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from "@azure/msal-browser";
import { apiRequest } from './authConfig';
import authInstance from './authInstance';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from './common/TelemetryService'
import WebSocketProvider, { WebSocketContext } from './contexts/WebSocket'

// import GlobalStyle from '@cayenne/springboard.components/styles/GlobalStyle'
// import { THEME } from '@cayenne/springboard.components/styles/theme'
// import ThemeProvider from '@cayenne/springboard.components/styles/ThemeProvider'
// import { ThemeProvider } from '@material-ui/core';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });

ai.initialize(process.env.REACT_APP_APPINSIGHTS!, history)

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history);

class Index extends React.Component {
    render() {
        return (
            <MsalProvider instance={authInstance}>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={apiRequest}>
                    <Provider store={store}>
                        {/* <ThemeProvider > */}
                        <CssBaseline />
                        {/* <GlobalStyle /> */}
                        {/* <WebSocketProvider> */}
                        <ConnectedRouter history={history}>
                            <App />
                        </ConnectedRouter>
                        {/* </WebSocketProvider> */}
                        {/* </ThemeProvider> */}
                    </Provider>
                </MsalAuthenticationTemplate>
            </MsalProvider>)
    }
}
const WithAI = withAITracking(ai.reactPlugin!,
    Index)
// ThemeProvider etc. is here to support future Cayenne/springboard.components integration
ReactDOM.render(
    <WithAI />,
    document.getElementById('root'));

registerServiceWorker();
